module.exports = __webpack_public_path__ + "img/wr_2.43eb8ba8.png";